/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Debtor_Entity_TypeInputs */

const en_case_field_debtor_entity_type = /** @type {(inputs: Case_Field_Debtor_Entity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debtor type`)
};

const pt_br2_case_field_debtor_entity_type = /** @type {(inputs: Case_Field_Debtor_Entity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de devedor`)
};

/**
* | output |
* | --- |
* | "Debtor type" |
*
* @param {Case_Field_Debtor_Entity_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_debtor_entity_type = /** @type {((inputs?: Case_Field_Debtor_Entity_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Debtor_Entity_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_debtor_entity_type(inputs)
	return pt_br2_case_field_debtor_entity_type(inputs)
});